import { theme } from '@styles';

export const profilePageLayoutByVariant = {
  desktop: {
    avatar: {
      height: 160,
      width: 160,
    },
    contentContainer: {
      flexDirection: 'row',
      gap: 0,
    },
    header: {
      left: 0,
      position: 'absolute',
      px: 156,
      right: 0,
    },
    pl: 156,
    pr: 156,
    px: 156,
    userInfo: {
      alignItems: 'center',
      flexDirection: 'column',
      mb: 0,
      mr: 64,
    },
    username: {
      color: theme.colors.white[100],
      ml: 0,
      mt: 24,
      variant: 'BN-regular-s32-lh28',
    },
  },
  laptop: {
    avatar: {
      height: 160,
      width: 160,
    },
    contentContainer: {
      flexDirection: 'row',
      gap: 0,
    },
    header: {
      left: 0,
      position: 'absolute',
      px: 24,
      right: 0,
    },
    pl: 24,
    pr: 24,
    px: 24,
    userInfo: {
      alignItems: 'center',
      flexDirection: 'column',
      mb: 0,
      mr: 64,
    },
    username: {
      color: theme.colors.white[100],
      ml: 0,
      mt: 24,
      variant: 'BN-regular-s32-lh28',
    },
  },
  mobile: {
    avatar: {
      height: 80,
      width: 80,
    },
    contentContainer: {
      flexDirection: 'column',
      gap: 3,
    },
    header: {
      left: 0,
      position: 'absolute',
      px: 24,
      right: 0,
    },
    pl: 24,
    pr: 24,
    px: 24,
    userInfo: {
      alignItems: 'center',
      flexDirection: 'row',
      mb: 29,
      mr: 24,
    },
    username: {
      color: theme.colors.white[100],
      ml: 24,
      mt: 0,
      variant: 'BN-regular-s32-lh28',
    },
  },
  tablet: {
    avatar: {
      height: 80,
      width: 80,
    },
    contentContainer: {
      flexDirection: 'column',
      gap: 3,
    },
    header: {
      left: 0,
      position: 'absolute',
      px: 24,
      right: 0,
    },
    pl: 24,
    pr: 24,
    px: 24,
    userInfo: {
      alignItems: 'center',
      flexDirection: 'row',
      mb: 29,
      mr: 24,
    },
    username: {
      color: theme.colors.white[100],
      ml: 24,
      mt: 0,
      variant: 'BN-regular-s32-lh28',
    },
  },
};

export const tagsProps = [
  {
    key: 'minutes_count',
    keyTag: 'time',
    translationName: 'ProfilePage.MinutesShort',
  },
  {
    key: 'lessons_count',
    keyTag: 'material',
    translationName: 'ProfilePage.Lessons',
  },
  {
    key: 'isTest',
    keyTag: 'test',
    translationName: 'ProfilePage.Test',
  },
  {
    key: 'peoplePassed',
    keyTag: 'peoplePassed',
    translationName: 'ProfilePage.PeoplePassed',
  },
];

export const formatDate = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const styles = {
  avatar: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    borderRadius: '50%',
  },
  container: {
    backgroundSize: 'contain',
    flexDirection: 'column',
    width: '100%',
  },
  netBackground: {
    flexDirection: 'column',
    pb: 121,
  },
  rank: {
    height: 45,
    width: 112,
  },
};
